import { useCallback, useEffect, useState } from "react";
import { AddedTag, CarrosselTitle, Container, ImoveisList, ImovelDescricao, ImovelItem, WarningText } from "./styles";
import { IcarrosselImoveis } from "../../types";
import { FaFolderOpen } from "react-icons/fa";
import { useAuth } from "../../context/auth";
import { Spin } from "antd";
import { SaveButton } from "../ModalAddToFolder/styles";

interface IProps {
    idImovel: number;
    handleCloseModal: () => void;
    onSuccess?: () => void;

}

export function ListImoveisFolders({ idImovel, handleCloseModal, onSuccess }: IProps) {

    const [imoveisCarrosseis, setImoveisCarrosseis] = useState<IcarrosselImoveis[]>([]);
    const [selecteds, setSelecteds] = useState<IcarrosselImoveis[]>([]);
    const { api, user } = useAuth();
    const [loading, setLoading] = useState(false);
    const [sendindRequests, setSendingRequests] = useState(false);

    const getCarrosseis = useCallback(async () => {
        setLoading(true)
        await api.get(`/portal/carrossel/list-carrossel?portal=hub&id_corretor=${user.id_corretor}`).then(response => {
            setImoveisCarrosseis(response.data.data)
        }).catch(e => console.log('não foi possivel carregar os carrosseis', e))
        setLoading(false)
    }, [api, user.id_corretor])

    const insertImovel = useCallback(async (carrossel: IcarrosselImoveis) => {
        const idsExistentes = carrossel.imoveis.map(imovel => imovel.id.toString());

        const allIds = [...idsExistentes, idImovel.toString()];

        await api.post(`/portal/carrossel/upsert/${carrossel.id}?portal=hub`, {
            imoveis: allIds,
            nome: carrossel.nome,
            publicado: carrossel.publicado
        });
    }, [idImovel, api]);

    const updateCarrosseis = async () => {
        setSendingRequests(true);

        try {
            await Promise.all(selecteds.map(carrossel => insertImovel(carrossel)));
        } catch (error) {
            console.error("Erro ao atualizar carrosséis:", error);
        } finally {
            onSuccess && onSuccess();
            getCarrosseis();
            setSelecteds([]);
            setSendingRequests(false);
            handleCloseModal();
        }
    };

    const handleSelects = async (carrossel: IcarrosselImoveis) => {
        if (selecteds.includes(carrossel)) {
            setSelecteds(selecteds.filter(item => item !== carrossel))
        } else {
            setSelecteds([...selecteds, carrossel])
        }
    }

    useEffect(() => {
        getCarrosseis()
    }, [getCarrosseis]);


    return (<>
        <Container>

            {loading && (
                <Spin size="large" />
            )}
            <ImoveisList>
                {imoveisCarrosseis.map((carrossel) => {
                    const jaAdicionado = carrossel.imoveis.some(imovel => imovel.id === idImovel);

                    return (
                        <ImovelItem
                            key={carrossel.id}
                            onClick={() => handleSelects(carrossel)}
                            style={{
                                backgroundColor: selecteds.includes(carrossel) ? '#0E2244' : undefined,
                                color: selecteds.includes(carrossel) ? '#fff' : undefined,
                            }}
                        >
                            <CarrosselTitle>
                                <FaFolderOpen /> {carrossel.nome}
                                {jaAdicionado && (
                                    <AddedTag>Já adicionado</AddedTag>

                                )}
                            </CarrosselTitle>

                            <ImovelDescricao style={{
                                color: selecteds.includes(carrossel) ? '#fff' : undefined,
                            }}>
                                {carrossel.descricao}
                            </ImovelDescricao>
                        </ImovelItem>
                    );
                })}

            </ImoveisList>

            {(imoveisCarrosseis.length === 0 && !loading) && (
                <WarningText>
                    Você não possui nenhuma pasta de imóveis ainda. Você pode criar uma através da área do corretor
                </WarningText>
            )}
        </Container>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <SaveButton disabled={sendindRequests || selecteds.length === 0} onClick={updateCarrosseis}>
                {sendindRequests ? 'Salvando...' : 'Salvar'}
            </SaveButton>
        </div>
    </>
    )
}